import type { PayloadAction, UnknownAction } from '@reduxjs/toolkit';

import type { IncomingMessageOfType } from '@/store/listeners/poc/incomingMessageMatchers';
import { cancelPendingAckTask } from '@/store/listeners/poc/pendingAckCoordinator';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';
import { isIncomingMessageOfType } from '@/store/listeners/poc/incomingMessageMatchers';
import type { AppStartListening } from '@/store/listeners/types';

export function registerIncomingMaintenanceListeners(
  startAppListening: AppStartListening
): void {
  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'file-ready-for-download-acknowledged'>> =>
      isIncomingMessageOfType(action, 'file-ready-for-download-acknowledged'),
    effect: (action) => {
      cancelPendingAckTask(action.payload.result.data.messageId);
    },
  });

  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'file-key-ready-for-download-acknowledged'>> =>
      isIncomingMessageOfType(action, 'file-key-ready-for-download-acknowledged'),
    effect: (action) => {
      cancelPendingAckTask(action.payload.result.data.messageId);
    },
  });

  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'check-for-keys-needing-regenerating'>> =>
      isIncomingMessageOfType(action, 'check-for-keys-needing-regenerating'),
    effect: (_action, listenerApi) => {
      const facilitationStatus = listenerApi.getState().fileKeyFacilitation.status;
      if (facilitationStatus !== 'running') {
        void listenerApi.dispatch(facilitateFileKeys());
      }
    },
  });

  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'six-created'>> =>
      isIncomingMessageOfType(action, 'six-created'),
    effect: (_action, listenerApi) => {
      void listenerApi.dispatch(fetchSixCatalogThunk());
    },
  });

  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'six-updated'>> =>
      isIncomingMessageOfType(action, 'six-updated'),
    effect: (_action, listenerApi) => {
      void listenerApi.dispatch(fetchSixCatalogThunk());
    },
  });

  startAppListening({
    matcher: (
      action: UnknownAction
    ): action is PayloadAction<IncomingMessageOfType<'six-deleted'>> =>
      isIncomingMessageOfType(action, 'six-deleted'),
    effect: (_action, listenerApi) => {
      void listenerApi.dispatch(fetchSixCatalogThunk());
    },
  });
}
